import type { IconName } from '@hotjar/hotsauce';
import type { EventMarker } from './types';

export const getIconName = (eventMarker: EventMarker, isDesktopRecording: boolean): IconName => {
  switch (eventMarker.type) {
    case 'input_choice_change':
    case 'select_change':
      return 'checkbox';
    case 'viewport_resize':
      return 'window_resize';
    case 'page':
      if (eventMarker.is_new_tab || eventMarker.is_visited_tab) {
        return 'tab';
      }
      return 'navigate';
    case 'key_press':
      return 'key_press';
    case 'scroll':
      return 'scroll';
    case 'mouse_click':
      return isDesktopRecording ? 'cursor_click' : 'finger_tap';
    case 'tag_recording':
      return 'lightning';
    case 'autotag_recording': {
      const behaviorName = eventMarker.subtype ? eventMarker.subtype : eventMarker.name;
      switch (behaviorName) {
        case 'rageclick':
          return 'rage_click';
        case 'uturn':
          return 'uturn';
        case 'wildscroll':
          return 'scroll';
        case 'madmouse':
          return 'mad_mouse';
        case 'poll':
          return 'chart_bar';
        case 'feedback':
          return 'comment';
        default:
          return 'lightning';
      }
    }
    case 'error':
      return 'warning_alt';
    case 'heatmap_screenshot':
      return 'camera';
    default:
      return 'lightning';
  }
};

export const getTargetUrl = (siteId: string | number, eventMarker: EventMarker): string => {
  if (eventMarker.type === 'page') {
    return eventMarker.url || '';
  }
  if (!eventMarker.autotag_properties || !eventMarker.autotag_properties.response_id) {
    // If there no response_id, it means there is no consent from the user so we shouldn't show any link
    return '';
  }
  if (eventMarker.autotag_properties.type === 'feedback') {
    return `/sites/${siteId}/feedback/responses/${eventMarker.autotag_properties.id}?frid=${eventMarker.autotag_properties.response_id}`;
  }
  if (eventMarker.autotag_properties.type === 'poll') {
    return `/sites/${siteId}/surveys/responses/${eventMarker.autotag_properties.id}?prid=${eventMarker.autotag_properties.response_id}`;
  }
  return '';
};
